var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounRequirement2209179Ffffff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512pt",
    height: "512pt",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80 108.69-10.344-10.344-11.312 11.312 21.656 21.656 37.656-37.656-11.312-11.312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 80h120v16h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 112h120v16h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 272h144v16h-144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 304h144v16h-144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.34 266.34-18.344 18.344-18.344-18.344-11.312 11.312 18.344 18.344-18.344 18.344 11.312 11.312 18.344-18.344 18.344 18.344 11.312-11.312-18.344-18.344 18.344-18.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 368h136v16h-136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 400h136v16h-136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.34 362.34-18.344 18.344-18.344-18.344-11.312 11.312 18.344 18.344-18.344 18.344 11.312 11.312 18.344-18.344 18.344 18.344 11.312-11.312-18.344-18.344 18.344-18.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 204.69-10.344-10.344-11.312 11.312 21.656 21.656 37.656-37.656-11.312-11.312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 176h176v16h-176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 208h176v16h-176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424 288h-40v-10.398c15.602 4.7188 32.488 2.4062 46.25-6.3359 13.758-8.7422 23.023-23.047 25.379-39.176 2.3555-16.133-2.4336-32.488-13.121-44.797-10.688-12.312-26.207-19.355-42.508-19.293h-16v-67.312l-84.688-84.688h-283.31v464h288v16h192v-136c-0.019531-19.09-7.6133-37.391-21.113-50.887-13.496-13.5-31.797-21.094-50.887-21.113zm-24 38.113-11.055-22.113h22.113zm15.48 103.1-15.48 15.477-15.48-15.48 15.48-100.59zm-15.48-165.21c-10.605-0.011719-20.773-4.2305-28.27-11.73-7.5-7.4961-11.719-17.664-11.73-28.27v-8h24c20.113 0.070312 39.293 8.5078 52.938 23.289-3.0312 7.3047-8.1523 13.551-14.727 17.949-6.5742 4.3984-14.301 6.75-22.211 6.7617zm39.586-44.129c-15.707-12.797-35.328-19.812-55.586-19.871h-24v-16h40c9.8633 0.03125 19.367 3.7148 26.68 10.336 7.3086 6.625 11.906 15.723 12.906 25.535zm-135.59-176.56 52.688 52.688h-52.688zm-272 420.69v-432h256v80h80v56h-24v56c0.011719 18.301 8.9766 35.438 24 45.887v18.586c-17.59 1.9844-33.832 10.371-45.637 23.562-11.805 13.191-18.34 30.266-18.363 47.965v104zm448 16h-160v-120c0.019531-14.012 5.2891-27.504 14.766-37.824 9.4766-10.32 22.477-16.715 36.434-17.93l12.527 25.055-16.246 105.49 32.52 32.52 32.52-32.52-16.223-105.49 12.504-25.059c13.957 1.2148 26.957 7.6094 36.434 17.93 9.4766 10.32 14.746 23.812 14.766 37.824z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounRequirement2209179Ffffff);
export default __webpack_public_path__ + "static/media/noun-requirement-2209179-FFFFFF.1e7ecc6a5aa625edd0304ed1483c88b8.svg";
export { ForwardRef as ReactComponent };